import {BuyBonusPopUpEvents, CheatModule, consoleLogger, injectable, NoBonusFilter, NoWinFilter} from '@gongxigames/framework/slot';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';
import {GameReelsetMatrix} from 'src/gameCheatPage/GameReelsetMatrix';
import {GameLogic} from 'src/server/GameLogic';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {RandomWildFeatureFilter} from 'src/filters/RandomWildFeatureFilter';
import {RubyCoinFilter} from 'src/filters/RubyCoinFilter';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {ScatterAnticipatorFilter} from 'src/filters/ScatterAnticipatorFilter';
import {ChosenFgTypeFilter} from 'src/filters/ChosenFgTypeFilter';
import {GameBonusFilter} from 'src/filters/GameBonusFilter';

@injectable()
export class GameCheatModule extends CheatModule {
    protected setupEvents(): void {
        super.setupEvents();
        this.on(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked);
    }

    protected onBuyButtonClicked(): void {
        this.resetPreviousFilters();
        this.logic.setFilter(null!);
    }

    protected initReelsetMatrix(): void {
        this._reelsetMatrix = new GameReelsetMatrix(this);
    }

    protected onSpinResponse(): void {
        super.onSpinResponse();
        consoleLogger.log((this.logic as GameLogic).isRandomWildFeature());
        consoleLogger.log((this.logic as GameLogic).getFinalSpinStopPositions().join(','));
        this.logic.nextAction !== Action.PICK && consoleLogger.log(this.logic.getNextReelSet().getReels());
    }

    protected addFilters(): void {
        this.addFilter(new NoWinFilter('NoWin'));
        this.addFilter(new NoBonusFilter('NoBonus'));
        this.addFilter(new RandomWildFeatureFilter('RandomWildFeature'));
        this.addFilter(new GameBonusFilter('PickBonus', Bonus.PICK_BONUS));
        this.addFilter(new RubyCoinFilter('TriggerRubyCoin'));
        this.addFilter(new ChosenFgTypeFilter('PicBonusFSType0', 0));
        this.addFilter(new ChosenFgTypeFilter('PicBonusFSType1', 1));
        this.addFilter(new ChosenFgTypeFilter('PicBonusFSType2', 2));
        this.addFilter(new ScatterAnticipatorFilter('3ScatterAnticipation', 3, WolfHaven.Scatter));
        this.addFilter(new ScatterAnticipatorFilter('4ScatterAnticipation', 4, WolfHaven.Scatter));
        this.addFilter(new ScatterAnticipatorFilter('5ScatterAnticipation', 5, WolfHaven.Scatter));
    }

    // add game symbols here
    protected addSymbols(): string[] {
        return [
            'wild_x3',
            'pic_a_x3',
            'pic_b_x3',
            'pic_c_x3',
            'a_x3',
            'k_x3',
            'q_x3',
            'j_x3',
            't_x3',
            'n_x3',
            'scatter_x3_en',
            'wild_activator_x3',
            'pic_a_double_x3',
            'pic_b_double_x3',
            'pic_c_double_x3',
            'a_double_x3',
            'k_double_x3',
            'q_double_x3',
            'j_double_x3',
            't_double_x3',
            'n_double_x3',
            'rubycoin_x3'
        ];
    }

    public getImagesData(): any {
        return {
            0: 'wild_x3',
            1: 'pic_a_x3',
            2: 'pic_b_x3',
            3: 'pic_c_x3',
            4: 'a_x3',
            5: 'k_x3',
            6: 'q_x3',
            7: 'j_x3',
            8: 't_x3',
            9: 'n_x3',
            10: 'scatter_x3_en',
            11: 'wild_activator_x3',
            12: 'pic_a_double_x3',
            13: 'pic_b_double_x3',
            14: 'pic_c_double_x3',
            15: 'a_double_x3',
            16: 'k_double_x3',
            17: 'q_double_x3',
            18: 'j_double_x3',
            19: 't_double_x3',
            20: 'n_double_x3',
            21: 'rubycoin_x3'
        };
    }
}
